import { Card, CardBody, Col, Container, Row } from 'reactstrap'
import CreateNewTicketOfferForm from '../../../../Componant/Application/Project/master/CreateNewTicketOfferForm'

const TicketOfferCreateContainer = () => {
  return (
    <Container fluid>
      <Row>
        <Col sm="12">
          <Card>
            <CardBody>
              <CreateNewTicketOfferForm />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default TicketOfferCreateContainer